const $megaMenuTogglerCollapsed = $('.mega-menu-toggler.collapsed');

$megaMenuTogglerCollapsed.on('click', function () {
  const firstUrlPath = window.location.pathname.split('/')[1];

  if (firstUrlPath === 'personal') {
    $('#mega-menu-tab-Personal').trigger('click');
  } else if (firstUrlPath === 'business') {
    $('#mega-menu-tab-Business').trigger('click');
  }
});

// toggle class value to manipulate in mobile
$('.mega-menu-toggler').on('click', function () {
  $('header').toggleClass('nav-open');
});

// hack: add homepage name, link to mega menu tabbed content
const megaTabPane = $('.mega-menu .tab-pane');
$.each(megaTabPane, function () {
  const homepageName = $(this).data('homepage');
  if (homepageName) {
    $(this).find('#homeLink a')
      .text(homepageName + ' Homepage')
      .attr('href', '/' + homepageName.toLowerCase());
  }
});
